import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as COLOR from 'constants/colors'
import {
  fetchProductionData,
  fetchEnvironmentData,
  fetchLogbookData,
} from 'reducers/dataBrowser/reducer'
import {
  MULTIPLE_ROW_TYPE,
  MULTIPLE_VALUE_TYPE,
  SINGLE_VALUE_TYPE,
} from 'constants/index'
import ControlChart from './ControlChart'
import LineChart from './LineChart'

class Filters extends Component {
  componentDidUpdate(prevProps) {
    const {
      dateRange,
      activeSite,
      activeLocus,
      activeLocusGroup,
      activeProdAndHealthType,
      activeEnvironmentType,
      activeLogbookType,
      fetchProductionData,
      fetchEnvironmentData,
      fetchLogbookData,
    } = this.props
    const productionValue = activeProdAndHealthType.get('value')
    const sensor = activeEnvironmentType.get('id')
    const sensorType = activeEnvironmentType.get('sensor_type_id')
    const logbookValue = activeLogbookType.get('id')

    const dateChanged =
      prevProps.dateRange.get('startDate').format('YYYY-MM-DD') !==
        dateRange.get('startDate').format('YYYY-MM-DD') ||
      prevProps.dateRange.get('endDate').format('YYYY-MM-DD') !==
        dateRange.get('endDate').format('YYYY-MM-DD')
    const siteChanged = prevProps.activeSite !== activeSite
    const locusChanged = prevProps.activeLocus !== activeLocus
    const locusGroupChanged = prevProps.activeLocusGroup !== activeLocusGroup
    const activeProdChanged =
      prevProps.activeProdAndHealthType.get('value') !== productionValue
    const activeEnvChanged =
      prevProps.activeEnvironmentType.get('name') !==
      activeEnvironmentType.get('name')
    const activeLBChanged =
      prevProps.activeLogbookType.get('id') !== logbookValue
    const isLocusGroupCheck = activeLocusGroup ? 'locus_group' : 'site'
    const entity = {
      [activeLocus ? 'locus' : isLocusGroupCheck]:
        activeLocus || activeLocusGroup || activeSite,
    }

    if (
      (dateChanged ||
        siteChanged ||
        locusChanged ||
        locusGroupChanged ||
        activeProdChanged) &&
      !!productionValue
    ) {
      fetchProductionData({
        type: productionValue,
        params: {
          ...entity,
          from: dateRange.get('startDate').format('YYYY-MM-DD'),
          to: dateRange.get('endDate').format('YYYY-MM-DD'),
        },
      })
    }

    if (
      (dateChanged ||
        siteChanged ||
        locusChanged ||
        locusGroupChanged ||
        activeLBChanged) &&
      !!logbookValue
    ) {
      fetchLogbookData({
        ...entity,
        event: logbookValue,
        from: dateRange.get('startDate').format('YYYY-MM-DD'),
        to: dateRange.get('endDate').format('YYYY-MM-DD'),
      })
    }

    if (
      (dateChanged || siteChanged || activeEnvChanged) &&
      !!sensor &&
      !!sensorType
    ) {
      fetchEnvironmentData({
        sensor,
        sensor_type: sensorType,
        site: activeSite,
        from: dateRange.get('startDate').format('YYYY-MM-DD'),
        to: dateRange.get('endDate').format('YYYY-MM-DD'),
      })
    }
  }

  getTypeLevel = type => {
    switch (type) {
      case MULTIPLE_ROW_TYPE:
        return 2
      case MULTIPLE_VALUE_TYPE:
        return 1
      case SINGLE_VALUE_TYPE:
      default:
        return 0
    }
  }

  renderCharts = () => {
    const {
      dateRange,
      combineCharts,
      prodDataLoader,
      envDataLoader,
      logbookData,
      productionData,
      environmentData,
      activeProdAndHealthType,
      activeEnvironmentType,
    } = this.props
    const prodLabel = activeProdAndHealthType.get('name')
    const envLabel = activeEnvironmentType.get('name')
    const prodData = productionData.toArray()
    const envData = environmentData.toArray()
    const doubleLoader = prodDataLoader || envDataLoader
    const rangeDiff = dateRange
      .get('endDate')
      .diff(dateRange.get('startDate'), 'days')
    const typeLevel = !!this.getTypeLevel(logbookData.get('type'))
    const sideOffset = rangeDiff <= 14 && !typeLevel

    if (combineCharts) {
      return (
        <div className="db-chart-box">
          <LineChart
            doubleDataset
            doubleLoader={doubleLoader}
            offset={sideOffset}
            leftLabel={prodLabel}
            rightLabel={envLabel}
            leftData={prodData}
            rightData={envData}
            leftColor={COLOR.DB_DARKBLUE}
            rightColor={COLOR.DB_PURPLE}
            range={dateRange}
          />
        </div>
      )
    }

    return (
      <>
        <div className="db-chart-box">
          <LineChart
            offset={sideOffset}
            label={prodLabel}
            loader={prodDataLoader}
            data={prodData}
            range={dateRange}
            color={COLOR.DB_DARKBLUE}
          />
        </div>
        <div className="db-chart-box">
          <LineChart
            offset={sideOffset}
            label={envLabel}
            loader={envDataLoader}
            data={envData}
            range={dateRange}
            color={COLOR.DB_PURPLE}
          />
        </div>
      </>
    )
  }

  render() {
    const {
      dateRange,
      logbookData,
      logbookDataLoader,
      activeProdAndHealthType,
      activeEnvironmentType,
      activeLogbookType,
      activeSite,
      activeLocus,
      activeLocusGroup,
      fetchLogbookData,
      fetchEnvironmentData,
      fetchProductionData,
      combineCharts,
    } = this.props
    const lgData = logbookData.toJS()
    const logbookValue = activeLogbookType.get('id')
    const productionValue = activeProdAndHealthType.get('value')
    const environmentValue = activeEnvironmentType.get('name')
    const typeLevel = this.getTypeLevel(logbookData.get('type'))
    const isLocusGroupCheck = activeLocusGroup ? 'locus_group' : 'site'
    const entity = {
      [activeLocus ? 'locus' : isLocusGroupCheck]:
        activeLocus || activeLocusGroup || activeSite,
    }

    return (
      <div className="db-charts">
        {this.renderCharts()}
        <ControlChart
          doubleChartsOn={combineCharts}
          label={activeLogbookType.get('name')}
          loader={logbookDataLoader}
          data={lgData}
          range={dateRange}
          logbookValue={logbookValue}
          entity={entity}
          typeLevel={typeLevel}
          productionValue={productionValue}
          activeSite={activeSite}
          environmentValue={environmentValue}
          fetchLogbookData={fetchLogbookData}
          fetchProductionData={fetchProductionData}
          fetchEnvironmentData={fetchEnvironmentData}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    dateRange: state.getIn(['sensor', 'dateRange']),
    activeLocus: state.getIn(['dataBrowser', 'activeLocus']),
    activeLocusGroup: state.getIn(['dataBrowser', 'activeLocusGroup']),

    // active filter types
    activeProdAndHealthType: state.getIn(['dataBrowser', 'activeProductions']),
    activeEnvironmentType: state.getIn(['dataBrowser', 'activeEnvironment']),
    activeLogbookType: state.getIn(['dataBrowser', 'activeLogbookType']),

    // loaders
    prodDataLoader: state.getIn(['dataBrowser', 'isLoadProductionData']),
    envDataLoader: state.getIn(['dataBrowser', 'isLoadEnvironmentData']),
    logbookDataLoader: state.getIn(['dataBrowser', 'isLoadLogbookData']),

    // chart data
    productionData: state.getIn(['dataBrowser', 'productionData']),
    environmentData: state.getIn(['dataBrowser', 'environmentData']),
    logbookData: state.getIn(['dataBrowser', 'logbookData']),
  }),
  {
    fetchProductionData,
    fetchEnvironmentData,
    fetchLogbookData,
  },
)(Filters)
